<template>
  <div class="item">
    <div class="child">
      <a class="subtitle" @click="show(ckey)"><div class="titledown">> {{ parentmsg.title }} </div></a>
      <div v-show="flag[ckey]">
      <mavon-editor
        class="replymd"
        :value="parentmsg.body"
        :subfield = "prop.subfield"
        :defaultOpen = "prop.defaultOpen"
        :toolbarsFlag = "prop.toolbarsFlag"
        :editable="prop.editable"
        :boxShadow="false"
        :scrollStyle="prop.scrollStyle"
      ></mavon-editor>
    </div>
    </div>
  </div>

</template>

<script>
    export default {
      name: "StarnoteList",
      data(){
        return {
          key:'',
          flag:[],

       }
      },
      methods:{
        show(key){
          //因为是下标的形式，数据不会实时渲染！
          //要使用this.$set的形式来修改它的值，这样就可以实时渲染，以实现切换的效果了。
          this.$set(this.flag, key, !this.flag[key])
         }
      },

      computed: {
        prop () {
          let data = {
            subfield: false,
            defaultOpen: 'preview',
            editable: false,
            toolbarsFlag: false,
            scrollStyle: true
          }
          return data
        }
      },

      mounted(){
        for(let i=0; i<this.parentmsg.length;i++){
          this.flag[i] = false
        }
      },

      props: ['parentmsg', 'ckey']
    }
</script>

<style scoped>
  .item{
    padding: 0.2rem 0.2rem;
    /*border: 1px dashed #ddd;*/
    margin-bottom: 0.2rem;

  }

  .child{
    display: block;

  }
  .subtitle{
    margin-bottom: 0.2rem;
    display: block;
  }

  .subtitle:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;

  }

  .replymd{
    min-height: auto;
    box-shadow: transparent;
  }

</style>
